import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: "pme-new-hero",
    templateUrl: './new-hero.component.html',
    styleUrls: ['./new-hero.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewHeroComponent implements OnInit {
  @Input() size: string;
  @Input() type: string;
  @Input() title: string;
  @Input() showButton: boolean;
  @Input() buttonName: string;
  @Input() redirectURL: string;

  iconPath: string;

  ngOnInit(): void {
    if (!this.redirectURL) {
      this.redirectURL = environment.serasaHomePage;
    }

    this.iconPath = this.getIconPath(this.type);
  }
  
  getIconPath(type): string {
    const path = "/assets/images/dialog-icons/";
    const file = {
      "info": "info.svg",
      "error": "error.svg",
      "shopping": "cart.svg",
      "warn": "warn.svg",
      "success": "success.svg",
    }[type];

    return path + file;
  }
}

